import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, ActivatedRoute } from "@angular/router";
import { FirebaseService } from '../services/firebase.service';

@Injectable()
export class EditGuideResolver implements Resolve<any> {

  constructor(public firebaseService: FirebaseService) { }

  resolve(route: ActivatedRouteSnapshot,) {
    return new Promise((resolve, reject) => {
      let guideId = route.paramMap.get('id');
      this.firebaseService.getGuide(guideId)
      .subscribe(
        data => {
          resolve(data);
        }
      );
    })
  }
}
